import React from 'react'
import ReactDOM from 'react-dom'
// import './index.css';
import App from './App'
import { Provider } from 'react-redux'
import Store from './redux/store/index'
import HashRouter from 'react-router-dom/HashRouter';

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

ReactDOM.render(
    <Provider store={Store}>
        <HashRouter>
            <App />
        </HashRouter>
    </Provider>,
    document.getElementById('root')
)
